import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  Backdrop,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";

const AddClient = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const filterData = location?.state?.filterData || {
    name: "",
    phone: "",
    email: "",
    country: "",
    companyType: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    status: "",
  };
  const open = location?.state?.open || "";

  const [clientData, setClientData] = useState({
    CD_Name: "",
    CD_Email: "",
    CD_Phone: "",
    CD_Address: "",
    CD_Country: "",
    CD_CompanyType: "",
    CD_ContactPerson: "",
    CD_ContactPerson_Email: "",
    CD_ContactPerson_Phone: "",
    CD_Notes: "",
    CD_Status: 1,
    CD_Branches: "",
    CD_UserName: "",
    CD_Password: "",
  });
  const [confirmPass, setConfirmPass] = useState("");

  const [errors, setErrors] = useState({});

  const inputRefs = {
    CD_Name: useRef(),
    CD_Country: useRef(),
    CD_CompanyType: useRef(),
    CD_ContactPerson_Email: useRef(),
    CD_ContactPerson_Phone: useRef(),
    CD_UserName: useRef(),
    CD_Password: useRef(),
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);

  const [loading, setLoading] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [companyTypeList, setCompanyTypeList] = useState([]);

  const mandatoryFields = [
    { field: "CD_Name", label: "Full Name", tab: 0 },
    { field: "CD_Country", label: "Country", tab: 0 },
    { field: "CD_CompanyType", label: "Company Type", tab: 0 },

    {
      field: "CD_ContactPerson_Email",
      label: "Contact Email",
      type: "email",
      tab: 1,
    },
    { field: "CD_ContactPerson_Phone", label: "Contact Phone Number", tab: 1 },

    { field: "CD_UserName", label: "Username", tab: 2 },
    { field: "CD_Password", label: "Password", type: "password", tab: 2 },
    {
      field: "confirmPass",
      label: "Confirm Password Field",
      type: "password",
      tab: 2,
    },
  ];

  const validateForm = () => {
    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{20}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    let firstErrorTab = null;

    for (let { field, label, type, tab } of mandatoryFields) {
      let value = field === "confirmPass" ? confirmPass : clientData[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
        if (firstErrorTab === null) firstErrorTab = tab;
      } else {
        if (type === "email" && !emailRegex.test(value)) {
          formErrors[field] = `Please enter a valid ${label}.`;
          if (firstErrorTab === null) firstErrorTab = tab;
        }

       

        if (field === "CD_UserName" && value.length < 3) {
          formErrors[field] = `${label} must be at least 3 characters long.`;
          if (firstErrorTab === null) firstErrorTab = tab;
        }

        if (type === "password" && !passwordRegex.test(value)) {
          formErrors[
            field
          ] = `${label} must be at least 8 characters, include uppercase, lowercase, number, and special character.`;
          if (firstErrorTab === null) firstErrorTab = tab;
        }
      }
    }

    // Confirm password match
    if (!confirmPass) {
      formErrors["confirmPass"] = "Confirm Password is required.";
      if (firstErrorTab === null) firstErrorTab = 2;
    } else if (clientData?.CD_Password !== confirmPass) {
      formErrors["confirmPass"] = "Password mismatch.";
      if (firstErrorTab === null) firstErrorTab = 2;
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      if (firstErrorTab !== null) {
        setTabValue(firstErrorTab);
      }

      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });

      return false;
    }

    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setClientData({
      ...clientData,
      [name]: value == "" ? null : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      if (confirmPass == clientData?.CD_Password) {
        setIsDisabled(true);
        setLoaderOpen(true);

        axiosAPI
          ?.post(`/Client/add`, clientData)
          .then((res) => {
            setIsDisabled(false);
            setLoaderOpen(false);

            if (res?.data?.success) {
              successNotify(res?.data?.message);
              navigate(`/Clients`, {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                  open: open,
                },
              });
            } else {
              infoNotify(res?.data?.message);
            }
          })
          .catch((err) => {
            errorNotify("Something went wrong!");
            setIsDisabled(false);
            setLoaderOpen(false);
          });
      } else {
        infoNotify("Password and Confirm password does not match!");
      }
    }
  };

  const getCountries = async () => {
    try {
      setLoading((prev) => ({ ...prev, countries: true }));
      const res = await axiosAPI.get(`/RecruitmentCountry/listCountry`);
      setCountryList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, countries: false }));
    }
  };

  const getCompanyType = async () => {
    try {
      setLoading((prev) => ({ ...prev, companyType: true }));
      const res = await axiosAPI.get(`/CompanyType/active/list`);
      setCompanyTypeList(res?.data?.data || []);
    } catch (err) {
      console.error("Active API failed, retrying without 'active'", err);
      try {
        const resFallback = await axiosAPI.get(`/CompanyType/list`);
        setCompanyTypeList(resFallback?.data?.data || []);
      } catch (fallbackErr) {
        console.error("Fallback API also failed", fallbackErr);
      }
    } finally {
      setLoading((prev) => ({ ...prev, companyType: false }));
    }
  };

  useEffect(() => {
    const firstErrorField = mandatoryFields.find(
      (field) => errors[field.field]
    );

    if (firstErrorField && inputRefs[firstErrorField.field]?.current) {
      inputRefs[firstErrorField.field].current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      inputRefs[firstErrorField.field].current.focus(); // optional
    }
  }, [errors]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCountries();
    getCompanyType();
  }, []);

  const [tabValue, setTabValue] = useState(0);

  const [tabs, setTabs] = useState([
    "Basic Information",
    "Contact Person Details ",
    "Additional Information",
  ]);

  const handleSubChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
      >
        Add Client
      </Typography>

      {/* Tabs ========================================================================================================================================================================== */}
      <Grid container spacing={2} sx={{ maxWidth: "100vw", overflow: `auto` }}>
        <Grid item>
          <Tabs
            value={tabValue}
            onChange={handleSubChange}
            indicatorColor="error"
            textColor="error"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ fontFamily: "Geist, sans-serif", marginTop: "10px" }}
          >
            {tabs.map((label, index) => (
              <Tab
                key={label}
                label={label}
                sx={{
                  fontFamily: "Geist, sans-serif",
                  background: tabValue == index ? "#006CB8" : "#f5f9ffff",
                  border: "1px solid lightgrey",
                  borderBottom: "4px solid #EAB308",
                  color: tabValue == index ? "white" : "black",
                  fontWeight: tabValue == index ? 600 : 500,
                  fontSize: `14px`,
                  letterSpacing: "1px",
                  minWidth: "150px",
                  minHeight: "60px",
                  marginRight: "5px",
                }}
              />
            ))}
          </Tabs>
        </Grid>
      </Grid>

      {/* Basic Information */}
      {tabValue == 0 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
            minHeight: "200px",
          }}
        >
          <Grid container spacing={2}>
            {/* Client Name */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Name <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="Full Name"
                placeholder="Enter Client Name"
                name="CD_Name"
                value={clientData.CD_Name}
                onChange={handleChange}
                inputRef={inputRefs.CD_Name}
                error={!!errors.CD_Name}
              />
            </Grid>

            {/* Email */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Email
              </Typography>
              <TextInput
                label="Email Address"
                placeholder="Enter Email Address"
                type="email"
                name="CD_Email"
                value={clientData.CD_Email}
                onChange={handleChange}
              />
            </Grid>

            {/* Phone Number */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Contact Number
              </Typography>
              <TextInput
                label="Phone Number"
                placeholder="Enter Contact Number"
                type="tel"
                name="CD_Phone"
                value={clientData.CD_Phone}
                onChange={handleChange}
                // allowOnlyNumbers={true}
                maxLength={20}
              />
            </Grid>

            {/* Address */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Address
              </Typography>
              <TextAreaInput
                label="Address"
                placeholder="Enter Address"
                name="CD_Address"
                value={clientData.CD_Address}
                onChange={handleChange}
              />
            </Grid>

            {/* Country Selection */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Country <span style={{ color: "red" }}> * </span>
              </Typography>
              <SelectInput
                name="CD_Country"
                value={clientData.CD_Country}
                options={countryList?.map((item) => ({
                  value: item?.CL_ID,
                  label: item?.CL_Name,
                }))}
                placeholder="Select Country"
                onChange={handleChange}
                inputRef={inputRefs.CD_Country}
                error={!!errors.CD_Country}
                loading={loading?.countries}
              />
            </Grid>

            {/* Company Type */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Company Type <span style={{ color: "red" }}> * </span>
              </Typography>
              <SelectInput
                name="CD_CompanyType"
                value={clientData.CD_CompanyType}
                options={companyTypeList?.map((item) => ({
                  value: item.CT_Id,
                  label: item.CT_Name,
                }))}
                placeholder="Select Company Type"
                onChange={handleChange}
                inputRef={inputRefs.CD_CompanyType}
                error={!!errors.CD_CompanyType}
                loading={loading?.companyType}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Contact Person Details */}
      {tabValue == 1 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
            minHeight: "200px",
          }}
        >
          <Grid container spacing={2}>
            {/* Contact Person Name */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Name
              </Typography>
              <TextInput
                label="Contact Person Name"
                placeholder="Enter Contact Person's Name"
                name="CD_ContactPerson"
                value={clientData.CD_ContactPerson}
                onChange={handleChange}
              />
            </Grid>

            {/* Contact Person Email */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Email <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="Contact Person Email"
                placeholder="Enter Contact Person's Email Address"
                type="email"
                name="CD_ContactPerson_Email"
                value={clientData.CD_ContactPerson_Email}
                onChange={handleChange}
                inputRef={inputRefs.CD_ContactPerson_Email}
                error={!!errors.CD_ContactPerson_Email}
              />
            </Grid>

            {/* Contact Person Phone Number */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Contact Number
              <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="Phone Number"
                placeholder="Enter Contact Number"
                type="tel"
                name="CD_ContactPerson_Phone"
                value={clientData.CD_ContactPerson_Phone}
                onChange={handleChange}
                // allowOnlyNumbers={true}
                maxLength={20}
                inputRef={inputRefs.CD_ContactPerson_Phone}
                error={!!errors.CD_ContactPerson_Phone}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Additional Information */}
      {tabValue == 2 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
            minHeight: "200px",
          }}
        >
          <Grid container spacing={2}>
            {/* Branches */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Branches
              </Typography>
              <TextInput
                label="Branches"
                placeholder="Branches"
                name="CD_Branches"
                value={clientData.CD_Branches}
                onChange={handleChange}
              />
            </Grid>

            {/* Client Username */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Username <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="User Name"
                placeholder="Enter Username"
                name="CD_UserName"
                value={clientData.CD_UserName}
                onChange={handleChange}
                inputRef={inputRefs.CD_UserName}
                error={!!errors.CD_UserName}
              />
            </Grid>

            {/* Client Password */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Password <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="Password"
                placeholder="Enter Password"
                name="CD_Password"
                type="password"
                value={clientData.CD_Password}
                onChange={handleChange}
                inputRef={inputRefs.CD_Password}
                error={!!errors.CD_Password}
              />
            </Grid>

            {/* Confirm Password*/}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Confirm Password <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="Password"
                placeholder="Confirm Password"
                type="password"
                value={confirmPass}
                onChange={(e) => {
                  setConfirmPass(e?.target.value);
                }}
                error={!!errors.confirmPass}
                inputRef={inputRefs.confirmPass}
              />
            </Grid>

            {/* Client Status */}
            {/* <Grid item sx={{ padding: "5px" }} xs={12} sm={12} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            name="CD_Status"
            value={clientData.CD_Status}
            options={[
              { value: 1, label: "Active" },
              { value: 2, label: "Inactive" },
            ]}
            placeholder="Select Status"
            onChange={handleChange}
            error={!!errors.CD_Status}
          />
        </Grid> */}

            {/* Notes */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Notes
              </Typography>
              <TextAreaInput
                label="Notes"
                placeholder="Notes"
                name="CD_Notes"
                value={clientData.CD_Notes}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Buttons */}
     <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate(`/Clients`, {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                  open: open,
                },
              });
            }}
          >
            Cancel
          </CommonButton>
        </Grid>

        {/* Back - Visible if not on first tab */}
        {tabValue > 0 && (
          <Grid item>
            <CommonButton
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => setTabValue((prev) => prev - 1)}
            >
              Back
            </CommonButton>
          </Grid>
        )}

        {/* Next - Visible if not on last tab */}
        {tabValue < tabs?.length - 1 && (
          <Grid item>
            <CommonButton
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => setTabValue((prev) => prev + 1)}
            >
              Next
            </CommonButton>
          </Grid>
        )}

        {tabValue === tabs?.length - 1 && (
          <Grid item>
            <CommonButton
              variant="contained"
              customColor="#007BFF"
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {isDisabled ? "Saving..." : "Save"}
            </CommonButton>
          </Grid>
        )}
      </Grid>

      {/* Loader Backdrop */}
      <Backdrop
        open={loaderOpen}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: "#fff",
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Paper>
  );
};

export default AddClient;
